<template>
  <div
    class="tw-flex tw-gap-[16px] tw-flex-wrap tw-items-center tw-justify-end tw-py-[24px] tw-border-t tw-border-[rgba(0,0,0,0.1)]"
  >
    <div class="tw-grow">
      <my-checkbox :value="selectedContacts.includes(item.id)" @input="selected">
        <div class="tw-flex tw-flex-col md:tw-flex-row tw-items-start md:tw-items-center">
          <div
            class="tw-flex tw-justify-center tw-min-w-[0] md:tw-min-w-[124px] mb-[6px] md:mb-[0]"
          >
            <status-badge :status="item.status" />
          </div>
          <div class="tw-text-[16px] md:tw-text-[18px] tw-text-[var(--my-black)]">
            {{ `${item.first_name} ${item.last_name}` }}
          </div>
        </div>
      </my-checkbox>
    </div>
    <div class="tw-flex tw-gap-x-[10px] tw-items-center">
      <div
        v-if="item.status === 'donated'"
        class="tw-text-[16px] md:tw-text-[18px] tw-text-[var(--my-black)]"
      >
        {{
          item.expected_donation_currency
            ? new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: item.expected_donation_currency,
              }).format(item.expected_donation_amount)
            : item.expected_donation_amount || 0
        }}
      </div>
      <div v-else class="tw-flex tw-gap-x-[10px]">
        <contact-list-item-link :data="item.phone" type="tel" class="tw-w-[34px] tw-h-[34px]" />
        <contact-list-item-link :data="item.phone" type="sms" class="tw-w-[34px] tw-h-[34px]" />
        <contact-list-item-link :data="item.email" type="email" class="tw-w-[34px] tw-h-[34px]" />
        <contact-list-item-link
          :data="item.phone"
          type="whatsapp"
          class="tw-w-[34px] tw-h-[34px]"
        />
      </div>
      <router-link
        :to="`/my-contacts/${item.id}`"
        class="tw-flex tw-items-center tw-justify-center tw-w-[34px] tw-h-[34px] tw-text-[var(--my-text-color)] hover:tw-text-[var(--my-primary)] tw-transition-colors"
      >
        <icon-arrow-right />
      </router-link>
    </div>
  </div>
</template>

<script>
import myCheckbox from "@/views/donor-dashboard/my-contacts/ui/my-checkbox.vue";
import statusBadge from "@/views/donor-dashboard/my-contacts/ui/my-status-badge.vue";
import iconArrowRight from "@/views/donor-dashboard/my-contacts/icons/arrow-right.vue";
import contactListItemLink from "@/views/donor-dashboard/my-contacts/contact-list/contact-list-item/contact-list-item-link.vue";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {};
  },

  methods: {
    ...mapActions({
      selectedMyContactsHandler: "donorMyContacts/selectedMyContactsHandler",
      unSelectMyContactsHandler: "donorMyContacts/unSelectMyContactsHandler",
    }),

    selected(value) {
      if (value) {
        this.selectedMyContactsHandler(this.item.id);
      } else {
        this.unSelectMyContactsHandler(this.item.id);
      }
    },
  },

  beforeDestroy() {
    this.selectedMyContactsHandler();
  },

  computed: {
    ...mapState({
      selectedContacts: (state) => state.donorMyContacts.selectedContacts,
    }),
  },

  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },

  name: "contact-list-item",

  components: {
    myCheckbox,
    statusBadge,
    iconArrowRight,
    contactListItemLink,
  },
};
</script>

<style lang="scss" scoped>
.first {
  @media screen and (max-width: 767px) {
    border-top: none;
  }
}
</style>
